// Touch or No-Touch, that is the question!

// function isTouchDevice() {
//   return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
// }
// if (isTouchDevice() === true) {
//   $("body").toggleClass("touch");
// } else {
//   $("body").toggleClass("no-touch");
// }


// $('.msdw-slider-jacket').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   swipe: false,
//   arrows: false,
//   // if autoplay...
//   autoplay: true,
//   // use this to avoid
//   // page jumping bug
//   accessibility: false 
// });

// $('.slick-prev').click(function() {
//   $('.msdw-slider-jacket').slick('slickPrev');
// });
//
// $('.slick-next').click(function() {
//   $('.msdw-slider-jacket').slick('slickNext');
// });

// UNSLICK
// If needed, here's a fix for window resizing
// $(window).resize(function() {
//   $('.msdw-benefit-slider-mobile, .msdw-sport-slider-mobile').slick('resize');
// });

// $(window).on('orientationchange', function() {
//   $('.msdw-benefit-slider-mobile, .msdw-sport-slider-mobile').slick('resize');
// });
